<template>
  <eden-filter
    :width="270"
    :properties.sync="properties"
    :disabled="disabled"
    :loading="loading"
    @open="getData"
    @reset="reset"
    @filter="filter"
  />
</template>

<script>
export default {
  name: "PaymentLinkFilter",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      properties: {
        service: {
          key: "service",
          label: "Services",
          type: "list",
          options: [],
          value: [],
        },
        amount: {
          key: "amount",
          label: "Amount",
          type: "list",
          options: [
            {
              label: "0 - 20000",
              value: "0 - 20000",
            },
            {
              label: "20001 - 40000",
              value: "20001 - 40000",
            },
            {
              label: "40001 - 60001",
              value: "40001 - 60001",
            },
            {
              label: "60001 - 80000",
              value: "60001 - 80000",
            },
            {
              label: "80001 - 100000",
              value: "80001 - 100000",
            },
            {
              label: "100001 - 120000",
              value: "100001 - 120000",
            },
          ],
          value: [],
        },
      },
    };
  },
  computed: {
    services() {
      return this.$store.getters.services;
    },
  },
  watch: {
    clear() {
      if (this.clear) {
        this.reset();
      }
    },
    properties() {
      // alert("change");
    },
  },
  methods: {
    getData() {
      this.setServices();
    },
    setServices() {
      this.properties.service.options = this.services.map((service) => {
        return {
          label: this.formatText(service.service_name),
          value: service.service_name.toLowerCase(),
        };
      });
    },
    reset() {
      Object.keys(this.properties).forEach((key) => {
        this.properties[key].value = [];
      });
    },
    filter() {
      let params = {
        params: {},
        paramsLabel: {},
      };

      Object.keys(this.properties).forEach((property) => {
        const { key, type, value } = this.properties[property];
        if (value && value.length) {
          switch (type) {
            case "list":
              params.paramsLabel[key] = this.properties[property];
              params.params[key] = value[0];
              break;
            case "daterange":
              params.params[key[0]] = this.properties[property].value[0];
              params.params[key[1]] = this.properties[property].value[1];
              params.paramsLabel[key] = this.properties[property];
              break;
            default:
              break;
          }
        } else if (type === "list") {
          params.params[key] = "all";
          params.paramsLabel[key] = "All";
        }
      });

      if (Object.keys(params.params).length) {
        this.$emit("filter", {
          params: params.params,
          paramsLabel: params.paramsLabel,
        });
      } else {
        this.$message.info("Filtering requires at least one property");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
